import { render, staticRenderFns } from "./PriceCombinationForm.vue?vue&type=template&id=473e1948&"
import script from "./PriceCombinationForm.vue?vue&type=script&lang=ts&"
export * from "./PriceCombinationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports